/* tslint:disable */
/* eslint-disable */
/**
 * 80s Conservation Club REST API
 * 80s Conservation Club REST API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: graham@matthewsapps.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MemberCampsite } from './MemberCampsite';
import {
    MemberCampsiteFromJSON,
    MemberCampsiteFromJSONTyped,
    MemberCampsiteToJSON,
} from './MemberCampsite';
import type { Metadata } from './Metadata';
import {
    MetadataFromJSON,
    MetadataFromJSONTyped,
    MetadataToJSON,
} from './Metadata';

/**
 * 
 * @export
 * @interface GetAccountMembershipCampsites200Response
 */
export interface GetAccountMembershipCampsites200Response {
    /**
     * 
     * @type {Array<MemberCampsite>}
     * @memberof GetAccountMembershipCampsites200Response
     */
    data: Array<MemberCampsite>;
    /**
     * 
     * @type {Metadata}
     * @memberof GetAccountMembershipCampsites200Response
     */
    metadata: Metadata;
}

/**
 * Check if a given object implements the GetAccountMembershipCampsites200Response interface.
 */
export function instanceOfGetAccountMembershipCampsites200Response(value: object): value is GetAccountMembershipCampsites200Response {
    if (!('data' in value) || value['data'] === undefined) return false;
    if (!('metadata' in value) || value['metadata'] === undefined) return false;
    return true;
}

export function GetAccountMembershipCampsites200ResponseFromJSON(json: any): GetAccountMembershipCampsites200Response {
    return GetAccountMembershipCampsites200ResponseFromJSONTyped(json, false);
}

export function GetAccountMembershipCampsites200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetAccountMembershipCampsites200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(MemberCampsiteFromJSON)),
        'metadata': MetadataFromJSON(json['metadata']),
    };
}

export function GetAccountMembershipCampsites200ResponseToJSON(value?: GetAccountMembershipCampsites200Response | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'data': ((value['data'] as Array<any>).map(MemberCampsiteToJSON)),
        'metadata': MetadataToJSON(value['metadata']),
    };
}

